module.exports = __webpack_public_path__ + "img/eb1a500.png";